import {Box, Checkbox, IconButton, Typography} from "@mui/material";
import {IndeterminateCheckBox as IndeterminateCheckBoxIcon} from "@mui/icons-material";
import React from "react";
import {CHECK_ALL, COLLAPSED, UNCHECK_ALL, useMuseumFilterDispatch, useMuseumFilterState} from "./museumFilterContext";
import {ChevronRight as ChevronRightIcon} from '@mui/icons-material';

export const ExpandedToolbar = () => {
    const {
        checked,
        includeIds,
        yourMuseumsLabel,
    } = useMuseumFilterState();
    const dispatch = useMuseumFilterDispatch()

    const onCollapse = () => dispatch({type: COLLAPSED})

    const onCheck = () => {
        if(checked.length === includeIds.length) {
            dispatch({type: UNCHECK_ALL})
        } else {
            dispatch({type: CHECK_ALL})
        }
    }

    return (
        <>
            <IconButton onClick={onCollapse} edge={"start"} size={"large"}>
                <ChevronRightIcon />
            </IconButton>
            <Typography variant={"body2"} fontWeight={"bold"}>
                {yourMuseumsLabel} ({checked.length})
            </Typography>
            <Box flexGrow={1}/>
            <Checkbox
                checked={checked.length === includeIds.length}
                color={"primary"}
                onChange={onCheck}
                checkedIcon={<IndeterminateCheckBoxIcon />}
            />
        </>
    )
}